import dayjs from 'dayjs';
import { useMemo } from 'react';

import { DropdownOption } from '../../Dropdown';

type Props = {
  date: string;
  minDate: string;
  maxDate: string;
};

const useMonthOptions = ({ minDate, maxDate, date }: Props): DropdownOption[] =>
  useMemo(
    () =>
      dayjs.months().map((month, monthIndex) => ({
        label: month,
        value: `${monthIndex}`,
        isDisabled:
          (dayjs(minDate).year() === dayjs(date).year() &&
            dayjs(minDate).month() > monthIndex) ||
          (dayjs(maxDate).year() === dayjs(date).year() &&
            dayjs(maxDate).month() < monthIndex),
      })),
    [date, maxDate, minDate],
  );

export default useMonthOptions;
